<template>
<div class="container-fluid" id="dashboard_wrap">

	<ForumList category="search_results" />

	
</div>
</template>


<script>
import ForumList from '../../components/forum/ForumList.vue';

export default {
	name: "SearchResults",
	components:{ 
		ForumList
	},
	props: {
	},
	data() {
		return {
		}
	},
	computed:{
	},
	mounted() {
	},
	watch: {
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>